import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../components/Renewal/Header";
import TopBack from "../../components/Renewal/TopBack";

const Liability = (props) => {
	const [liabilityCoverage, setLiabilityCoverage] = useState(1);
	const renewalData = useSelector((state) => state.RenewalData);
	const renewalId = useSelector((state) => state.RenewalId);

	let history = useHistory();
	const dispatch = useDispatch();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (renewalData) {
			setLiabilityCoverage(renewalData.liability_coverage);
		}
	}, [renewalData]);

	const changeLiability = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, liability_coverage: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	const submitLiability = () => {
		dispatch({
			type: "LIABILITY_CHANGE",
			payload: liabilityCoverage,
		});
		history.goBack();
	};

	return (
		<div className="liability general d-flex justify-content-center">
			<div className="otcontainer1 nopadding">
				<TopBack />
				<div className="">
					<div className="col">
						<h1 className="otmt-2 otmb-2" style={{ color: "#00778a" }}>
							Liability Protection
						</h1>
						<p className="mt-3">
							Liability coverage provides protection if you harm someone else or
							their property: including track property.
						</p>
						<p className="">Select the amount of liability coverage:</p>
					</div>
					<div className="row">
						<div
							className="d-flex flex-column mb-5 otmt-2 "
							role="group"
							aria-label="Basic radio toggle button group"
						>
							<div className=" d-flex justify-content-center">
								<input
									type="radio"
									className="btn-check"
									name="btnradio"
									id="btnradio1"
									autoComplete="off"
									defaultChecked
									onClick={() => {
										setLiabilityCoverage(1_000_000);
										changeLiability(1_000_000);
									}}
								></input>
								<label
									className={`col-11 col-md-6 btn3 mb-2 ${
										liabilityCoverage === 1_000_000 && "active"
									}`}
									style={{ maxWidth: "328px" }}
									htmlFor="btnradio1"
								>
									$1,000,000
								</label>
							</div>
							<div className=" d-flex justify-content-center">
								<input
									type="radio"
									className="btn-check"
									name="btnradio"
									id="btnradio2"
									autoComplete="off"
									onClick={() => {
										setLiabilityCoverage(2_000_000);
										changeLiability(2_000_000);
									}}
								/>
								<label
									className={`col-11 col-md-6 btn3 mb-2 ${
										liabilityCoverage === 2_000_000 && "active"
									}`}
									htmlFor="btnradio2"
									style={{ maxWidth: "328px" }}
								>
									$2,000,000
								</label>
							</div>
							<div className="d-flex justify-content-center">
								<input
									type="radio"
									className="btn-check"
									name="btnradio"
									id="btnradio3"
									autoComplete="off"
									onClick={() => {
										setLiabilityCoverage(0);
										changeLiability(0);
									}}
								></input>
								<label
									className={`col-11 col-md-6 btn3 mb-0 ${
										liabilityCoverage || "active"
									}`}
									htmlFor="btnradio3"
									style={{ maxWidth: "328px" }}
								>
									Remove liability coverage
								</label>
							</div>
							<div className="d-flex justify-content-center otmt-4 otmb-4">
								<button
									className="btn btn-lg btn2 col-4 col-md-3 mb-2"
									onClick={() => submitLiability()}
								>
									SAVE AND EXIT
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Liability;
